// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__+Wc84","item":"Sidebar_item__ACE2K"};